import React from 'react';
import { TrashIcon, ListChecksIcon } from '@phosphor-icons/react';

const TaskDistributionSearchActions = ({
  value,
  onChange,
  placeholder,
  onSelectVisible,
  onClear
}) => (
  <div className="flex min-w-0 flex-nowrap gap-2">
    <input
      type="search"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={placeholder}
      className="min-w-0 flex-[1_1_0%] sm:flex-[1_1_240px] rounded-xl border border-line bg-surface-2 px-3 py-2.5 text-sm text-content outline-none transition placeholder:text-content-muted focus:border-amber"
    />
    <button
      type="button"
      onClick={onSelectVisible}
      className="shrink-0 rounded-xl border border-line bg-surface px-3 py-2.5 text-xs font-semibold text-content transition hover:border-amber"
    >
      <ListChecksIcon size={16}/>
    </button>
    <button
      type="button"
      onClick={onClear}
      className="shrink-0 rounded-xl border border-line bg-surface-2 px-3 py-2.5 text-xs font-semibold text-content-muted transition hover:border-rose-500 hover:text-rose-200"
    >
      <TrashIcon size={16} />
    </button>
  </div>
);

export default TaskDistributionSearchActions;
